import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {CARRIER_TYPE_VALUES} from '@/modules/smart-compounders/constants'
import {SortSchema} from '@cypro/ui/schemas'
import {AddSolutionSchema} from '@cypro/engine/mutators'
import * as z from 'zod'

export const NewSolutionPageSearchSchema = z.object({
  solutionId: z.uuidv7().optional(),
})

export const SolutionsSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      categories: z.array(z.uuidv7()).optional(),
      types: z.array(z.uuidv7()).optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export const SolutionFormSchema = AddSolutionSchema.omit({concentrationUnitId: true, medicationProfiles: true}).extend({
  concentrationUnitId: z.array(z.uuidv7()).nonempty(),
  medicationProfiles: z.array(MedicationProfileFormSchema).nonempty(),
  carrierType: CARRIER_TYPE_VALUES,
})
export type SolutionFormSchema = z.infer<typeof SolutionFormSchema>
